import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sendNotification as sendNotificationApi } from "../api/code"; // Import your function

// Async thunk for sending notifications
export const sendNotification = createAsyncThunk(
  "sendNotification/send",
  async (
    { verificationCode, firebaseIntegrationFile },
    { rejectWithValue }
  ) => {
    // console.log(verificationCode);
    try {
      const response = await sendNotificationApi({
        verificationCode,
        firebaseIntegrationFile,
      }); // Call the imported function
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice definition
const sendNotificationSlice = createSlice({
  name: "sendNotification",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotification.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendNotification.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const sendNotificationReducer = sendNotificationSlice.reducer;
